import { CircleProps, useNodeMouseHandlers } from '@nivo/circle-packing'
import { animated } from '@react-spring/web'
import { useRouter } from 'next/router'
import React from 'react'
import { useEffect } from 'react'
import { sha256 } from '../../global/Identigradient'

export const CollectorCircle = <RawDatum,>({
  node,
  style,
  onMouseEnter,
  onMouseMove,
  onMouseLeave,
  onClick,
}: CircleProps<RawDatum>): JSX.Element => {
  const [color1, setColor1] = React.useState('rgba(0,0,0,0.0)')
  const [color2, setColor2] = React.useState('rgba(0,0,0,0.0)')
  const router = useRouter()

  const handlers = useNodeMouseHandlers<RawDatum>(node, {
    onMouseEnter,
    onMouseMove,
    onMouseLeave,
    onClick,
  })

  useEffect(() => {
    sha256(node.id).then((hash) => {
      setColor1(`hsl(${(hash[0] / 256) * 360}deg, ${100}%, ${3 * (hash[1] / 256 / 4) * 100}%)`)
      setColor2(`hsl(${(hash[2] / 256) * 360}deg, ${100}%, ${((3 * hash[3]) / 256 / 4) * 100}%)`)
    })
    console.log(node.data)
  }, [node.id])

  const openProfile = (address: string): void => {
    if (node.id === '') return
    router.push(`/${address}`)
  }

  return (
    <svg onClick={() => openProfile(node.id)}>
      <defs>
        <pattern
          id={`image-${node.id}`}
          height="100%"
          width="100%"
          patternContentUnits="objectBoundingBox"
        >
          <image
            preserveAspectRatio="xMidYMid slice"
            width="1"
            height="1"
            xlinkHref={
              (node.data as any).user?.profileImageUri
                ? `https://glassimg.imgix.net/${
                    (node.data as any).user?.profileImageUri
                  }?w=500&h=500&fit=crop&crop=faces&fm=webp`
                : ''
            }
          ></image>
        </pattern>
        <linearGradient id={`gradient-${node.id}`} x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor={color1} />
          <stop offset="100%" stopColor={color2} />
        </linearGradient>
        <radialGradient id={`outer`} x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor={`rgba(255, 255, 255, 0)`} />
          <stop offset="85%" stopColor={`rgba(255, 255, 255, 0.05)`} />
          <stop offset="100%" stopColor={`rgba(255, 255, 255, 0.15)`} />
        </radialGradient>
        <radialGradient id={`radial-${node.id}`} x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor={`rgba(255, 255, 255, 0)`} />
          <stop offset="50%" stopColor={`rgba(255, 255, 255, 0.12)`} />
          <stop offset="100%" stopColor={`rgba(255, 255, 255, 0.3)`} />
        </radialGradient>
      </defs>
      {node.id !== '' && (
        <animated.circle
          key={`gradient-${node.id}`}
          cx={style.x}
          cy={style.y}
          r={style.radius}
          fill={`url(#gradient-${node.id})`}
          cursor={'pointer'}
        />
      )}
      {node.id === '' ? (
        <animated.circle
          key={`outer-${node.id}`}
          cx={style.x}
          cy={style.y}
          r={style.radius}
          fill={`url(#outer)`}
        />
      ) : (
        <animated.circle
          key={`radial-${node.id}`}
          cx={style.x}
          cy={style.y}
          r={style.radius}
          fill={`url(#radial-${node.id})`}
          cursor={'pointer'}
        />
      )}

      {node.id !== '' && (
        <animated.circle
          key={`image-${node.id}`}
          cx={style.x}
          cy={style.y}
          r={style.radius}
          fill={`url(#image-${node.id})`}
          cursor={'pointer'}
          onMouseEnter={handlers.onMouseEnter}
          onMouseMove={handlers.onMouseMove}
          onMouseLeave={handlers.onMouseLeave}
          onClick={handlers.onClick}
        />
      )}
    </svg>
  )
}
